import { useContext } from 'react';
import {
    Typography,
    IconButton,
    CircularProgress,
    Grid,
    Card,
    CardMedia,
    CardContent,
    CardActions,
} from '@mui/material';
import { ProjectsContext } from './ProjectsContext';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
const ProjectsGrid = () => {
    const {
        projects,
        loading,
        handleOpenDialog,
        handleOpenDeleteDialog,
        backendUrl,
    } = useContext(ProjectsContext);
    return (
        <Grid container spacing={3}>
            {loading && projects.length === 0 ? (
                <Grid
                    item
                    xs={12}
                    sx={{ display: 'flex', justifyContent: 'center', py: 5 }}
                >
                    <CircularProgress />
                </Grid>
            ) : projects.length === 0 ? (
                <Grid
                    item
                    xs={12}
                    sx={{ display: 'flex', justifyContent: 'center', py: 5 }}
                >
                    <Typography variant="body1">
                        No projects found. Add your first project!
                    </Typography>
                </Grid>
            ) : (
                projects.map((project) => {
                    // Determine which image to display
                    let imageSrc;
                    if (project.images && project.images.length > 0) {
                        const filename = project.images[0].split('/').pop();
                        // In development, use direct file path, in production use backend
                        imageSrc =
                            import.meta.env.MODE === 'development'
                                ? `/mnt/media_storage/dn_right/projects/${filename}`
                                : `${backendUrl}/media/projects/${filename}`;
                    }
                    return (
                        <Grid
                            item
                            xs={12}
                            sm={6}
                            md={4}
                            key={project._id || project.id}
                        >
                            <Card>
                                <CardMedia
                                    component="img"
                                    height="200"
                                    image={imageSrc}
                                    alt={project.title}
                                />
                                <CardContent>
                                    <Typography variant="h6" gutterBottom>
                                        {project.title}
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        color="primary"
                                        sx={{
                                            display: '-webkit-box',
                                            WebkitBoxOrient: 'vertical',
                                            WebkitLineClamp: 3,
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            mb: 2,
                                        }}
                                    >
                                        {project.description}
                                    </Typography>
                                    <Typography variant="body2" color="primary">
                                        <strong>Category:</strong>{' '}
                                        {project.category}
                                    </Typography>
                                    <Typography variant="body2" color="primary">
                                        <strong>Completed:</strong>{' '}
                                        {new Date(
                                            project.completionDate
                                        ).toLocaleDateString()}
                                    </Typography>
                                    <Typography variant="body2" color="primary">
                                        <strong>Featured:</strong>{' '}
                                        {project.featured ? 'Yes' : 'No'}
                                    </Typography>
                                    {project.images &&
                                        project.images.length > 1 && (
                                            <Typography
                                                variant="body2"
                                                color="primary"
                                            >
                                                <strong>Images:</strong>{' '}
                                                {project.images.length}
                                            </Typography>
                                        )}
                                </CardContent>
                                <CardActions>
                                    <IconButton
                                        size="small"
                                        color="primary"
                                        onClick={() =>
                                            handleOpenDialog(project)
                                        }
                                    >
                                        <EditIcon />
                                    </IconButton>
                                    <IconButton
                                        size="small"
                                        color="error"
                                        onClick={() =>
                                            handleOpenDeleteDialog(project)
                                        }
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                </CardActions>
                            </Card>
                        </Grid>
                    );
                })
            )}
        </Grid>
    );
};

export default ProjectsGrid;
